import {useEffect, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {NewsModal, ThemeModeProvider} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import {KTIcon} from '../../_metronic/helpers'

const MasterLayout = () => {
  const location = useLocation()
  const [showIcons, setShowIcons] = useState(false)

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  const toggleIcons = () => {
    setShowIcons(!showIcons)
  }

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            <HeaderWrapper />
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid pb-20' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  <ToolbarWrapper />
                  <Content>
                    <Outlet />
                  </Content>
                </div>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>

        {/* begin:: Modals */}
        {/* <NewsModal /> */}
        {/* end:: Modals */}
        {/* <ScrollTop /> */}

        {/* <div className="chat-icon" onClick={toggleIcons}>
          <KTIcon iconName='messages' />
        </div>

        {showIcons && (
          <div className="extra-icons">
            <a href="https://eitaa.com/#" target="_blank" rel="noopener noreferrer">
              <KTIcon iconName='whatsapp' className="extra-icon-whatsapp" />
            </a>
            <a href="https://t.me/#" target="_blank" rel="noopener noreferrer">
              <KTIcon iconName='send' className="extra-icon-telegram" />
            </a>
          </div>
        )} */}
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
